import { render, staticRenderFns } from "./returnReports.vue?vue&type=template&id=57323388&"
import script from "./returnReports.vue?vue&type=script&lang=js&"
export * from "./returnReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports